import { Lucide, type LucideIconName } from "@react-native-vector-icons/lucide";
import { useTheme } from "~/styles/theme";

export type IconTone = "default" | "muted" | "inverse" | "accent";
export type IconSize = "small" | "medium" | "large" | number;

const iconSizes = { small: 14, medium: 18, large: 24 } as const;

export function Icon({
  name,
  size = "medium",
  tone = "default",
}: {
  name: LucideIconName;
  size?: IconSize;
  tone?: IconTone;
}) {
  const { colors } = useTheme();
  const color =
    tone === "muted"
      ? colors.muted
      : tone === "inverse"
        ? colors.inverse
        : tone === "accent"
          ? colors.accent
          : colors.ink;

  return (
    <Lucide
      color={color}
      name={name}
      size={typeof size === "number" ? size : iconSizes[size]}
    />
  );
}
